import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

export type BackButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> & {
  children: ReactNode;
};

/**
 * Soft pill back control — shared look for sub-screens and panels.
 */
export function BackButton({
  children,
  className,
  type = "button",
  ...props
}: BackButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "group inline-flex w-fit max-w-full items-center gap-1.5",
        "rounded-full border border-border/60 bg-surface-muted/80",
        "px-3 py-1.5 text-sm font-medium text-foreground-muted",
        "shadow-sm backdrop-blur-sm",
        "transition-[background-color,border-color,color,transform,box-shadow]",
        "duration-200 ease-out",
        "hover:border-border hover:bg-surface-muted hover:text-foreground",
        "active:scale-[0.97] active:shadow-none",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35",
        "disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    >
      <span
        aria-hidden
        className="inline-block text-base leading-none transition-transform duration-200 ease-out group-hover:-translate-x-0.5 group-active:-translate-x-0.5"
      >
        ←
      </span>
      <span className="truncate">{children}</span>
    </button>
  );
}
